// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._9-M-xAO5ulImRutOPUw5Gg\\=\\={width:24px;height:24px;font-weight:500}html[dir] ._9-M-xAO5ulImRutOPUw5Gg\\=\\={background-color:transparent;text-align:center}", ""]);
// Exports
exports.locals = {
	"selectAllIcon": "_9-M-xAO5ulImRutOPUw5Gg=="
};
module.exports = exports;
